import { z } from 'zod';
import type {
    GenerateReceiptPdfRequest,
    GenerateReceiptPdfResponse,
    ReceiptGenerationErrorCode,
} from '../receipt-ipc.types';
import { GetReceiptDataResponseSchema } from './samba-payment.schemas';

export const ReceiptGenerationErrorCodeSchema: z.ZodType<ReceiptGenerationErrorCode> = z.enum([
    'INVALID_REQUEST',
    'SETTINGS_ERROR',
    'TAB_NOT_FOUND',
    'RENDER_TIMEOUT',
    'TEMPLATE_LOAD_FAILED',
    'HYDRATION_FAILED',
    'PDF_GENERATION_FAILED',
    'PRINT_FAILED',
    'FILESYSTEM_ERROR',
    'UNKNOWN_ERROR',
]);

export const GenerateReceiptPdfRequestSchema: z.ZodType<GenerateReceiptPdfRequest> = z.object({
    payment_transaction_uuid: z.string().uuid(),
    receipt_data: GetReceiptDataResponseSchema,
    receipt_html: z.string().min(1),
    open_folder_after_generate: z.boolean().optional().default(true),
    auto_print_hardcopy: z.boolean().optional().default(false),
});

export const GenerateReceiptPdfResponseSchema: z.ZodType<GenerateReceiptPdfResponse> = z.object({
    success: z.boolean(),
    pdf_file_path: z.string().optional(),
    error_code: ReceiptGenerationErrorCodeSchema.optional(),
    error_message: z.string().optional(),
});
